import styled from "styled-components";

export const ModalContainer = styled.div`
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;

    box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.1), 0 10px 15px -3px rgba(0, 0, 0, 0.1);
`;

export const Content = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;

    padding: 20px;
    min-height: 127px;
`;

export const IconContainer = styled.div`
    flex-shrink: 0;
`;

export const IconCircle = styled.div`
    width: 36px;
    height: 36px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #f5f5f5;
    border-radius: 50%;

    color: #6a7282;
    font-size: 18px;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Title = styled.h2`
    margin: 0;

    color: #101828;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
`;

export const Description = styled.p`
    margin: 0;

    color: #6a7282;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;

    padding: 20px;

    border-top: 1px solid #ebebeb;
`;

export const CancelButton = styled.button`
    height: 34px;
    padding: 8px 16px;

    border: 1px solid #d6d6d6;
    border-radius: 8px;

    background: #ffffff;

    color: #364153;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1.25px;

    cursor: pointer;

    &:hover {
        background: #f9fafb;
    }
`;

export const DownloadButton = styled.button`
    height: 34px;
    padding: 8px 16px;

    border: none;
    border-radius: 8px;

    background: #700ac1;

    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1.25px;

    cursor: pointer;

    &:hover {
        background: #5d08a3;
    }
`;
